/**
 * @desc undefined
 */
import { AccountDto } from '@eastcoal/api/finance/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryMemberAccountParameter = never

const method = 'GET'
const url = '/finance/member/account'

export const queryMemberAccountApi = (
  params?: QueryMemberAccountParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AccountDto>({
    method,
    url,
    params,
    ...config
  })
}

queryMemberAccountApi.method = method
queryMemberAccountApi.url = url
